import Collapsed from './collapsed/collapsed';
import Expanded from './expanded/expanded';

const AiScribeModal = () => {
  return (
    <>
      <Expanded />
      <Collapsed />
    </>
  );
};

export default AiScribeModal;
